export default __webpack_public_path__ + "static/media/user.6653a3b8.svg";